<app-page>
	<section class="section-navigation-bg section-banner">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<h1 class="section-title-banner" translate>Contact and support</h1>
				</div>
			</div>
		</div>
	</section>

	<section class="section-padding">
		<div class="container">
			<div class="row">
				<div class="col-md-7">
					<h1 class="title" translate>SeltronHome platform status</h1>
					<p class="small">
						<a href="/status/current.html?lng=en" translate>Current status</a>
					</p>
					<h1 class="title" translate>Installation and use manual</h1>
					<p class="small">
						Navodila za
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD1_SLO"
							class="font-weight-bold"
							target="_blank"
							>GWD1</a
						>,
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD2_SLO"
							class="font-weight-bold"
							target="_blank"
							>GWD2</a
						>
						in
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD3_SLO"
							class="font-weight-bold"
							target="_blank"
							>GWD3</a
						>
						v slovenskem jeziku.
					</p>
					<p class="small">
						User and service manual for
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD1_EN"
							class="font-weight-bold"
							target="_blank"
							>GWD1</a
						>,
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD2_EN"
							class="font-weight-bold"
							target="_blank"
							>GWD2</a
						>
						and
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD3_EN"
							class="font-weight-bold"
							target="_blank"
							>GWD3</a
						>
						in english language.
					</p>
					<p class="small">
						Anleitung zur Installation und Nutzung fur
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD1_DE"
							class="font-weight-bold"
							target="_blank"
							>GWD1</a
						>,
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD2_DE"
							class="font-weight-bold"
							target="_blank"
							>GWD2</a
						>
						und
						<a
							[externalRedirect]="ASSETS_PATH.INSTRUCTIONS_GWD3_DE"
							class="font-weight-bold"
							target="_blank"
							>GWD3</a
						>
						auf Deutsch.
					</p>
					<h1 class="title" translate>About Seltron</h1>
					<p class="section-info">
						<span translate>Seltron d.o.o is headquartered at</span
						><a
							class="ml-1"
							[externalRedirect]="EXTERNAL_PATH.HOW_TO_FIND_SELTRON"
							>Tržaška cesta 85 A, Maribor, Slovenia</a
						>.
					</p>
					<p class="section-info" translate>
						In the Slovenian and European market we are known as the company,
						which – in the field of heating regulation – offers complete
						solutions. Our development strategy is based on 25 years of
						experience, promotion of innovations and a constant search for newer
						and better solutions.
					</p>
					<p class="section-info" translate>
						Our advantage is – thanks to the latest technology and several years
						of experience – that we are able quickly to adjust to all kinds of
						market conditions.
					</p>
					<p class="section-info" translate>
						The offer of our products is quite large: we offer a whole span of
						heating regulators, motor drives and temperature sensors. We are
						very present in this field in Slovenia, since our products represent
						more than 50 percent of the share of the Slovenian market.
					</p>
					<p class="section-info" *ngIf="language === 'sl'">
						Če ste iz Maribora ali okolice lahko komunikacijski vmesnik GWD, ki
						ste ga naročili v naši
						<a [externalRedirect]="EXTERNAL_PATH.SELTRON_PAGE"
							>spletni trgovini</a
						>, tudi osebno prevzamete v CENTRU varčnega ogrevanja.
					</p>
					<p class="section-info" translate>
						Our biggest priority when developing the third generation of heating
						regulators was designing them in such a way that they would be as
						user-friendly as possible.
					</p>
				</div>
				<div class="col-md-5">
					<h1 class="title" translate>Call us</h1>
					<p class="section-title" translate>+386 2 671 96 00</p>
					<p>
						<a href="mailto:info@seltronhome.com"
							><h4 translate>Send us a message</h4></a
						>
					</p>
				</div>
			</div>
		</div>
	</section>
</app-page>
